import React from 'react';

import { flagStyles } from '../settings';

const SvgMT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3624px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMT;
